import React from "react";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";

const Checkbox = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  return (
    <div
      className="form-group formarea-component"
      data-elementtype="checkbox"
      id={arrEle.elementid}
      style={{
        display: "block",
        visibility: fieldEle?.["display-hidden"] === 1 ? "hidden" : "",
      }}
    >
      <div className="form-check checkbox form-builder-element">
        {fieldEle?.["display-hidelabel"] !== 1 && (
          <label className="form-check-label">
            <input
              id={newElfromJSON}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="form-check-input"
              type="checkbox"
              disabled={fieldEle?.["display-disabled"] === 1}
              name={key}
              required={fieldEle?.["display-required"] === 1}
              value={formState[key] || ""}
              onChange={(e) =>
                store.dispatch(
                  setRendererFormState({ key, value: e.target.checked })
                )
              }
            />
            <span>{fieldEle?.["display-fieldlabel"]}&nbsp;</span>
            {fieldEle?.["display-tooltip"] && (
              <span className="label-tooltip">
                &nbsp;
                <i
                  className="fa fa-question-circle text-muted"
                  data-toggle="tooltip"
                  data-placement="right"
                  title={fieldEle?.["display-tooltip"]}
                ></i>
              </span>
            )}
            {fieldEle?.["display-required"] === 1 && " *"}
          </label>
        )}
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
